import PackagesHero      from '../components/packages/PackagesHero'
import PackageCard       from '../components/packages/PackageCard'
import PackageComparison from '../components/packages/PackageComparison'
import Testimonials      from '../components/home/Testimonials'
import CTA               from '../components/home/CTA'
import SectionTitle      from '../components/ui/SectionTitle'
import { usePackages }   from '../hooks/usePackages'

const FALLBACK_PACKAGES = [
  {
    id: 1,
    title: 'Small Celebration',       price: 15000, currency: 'EGP',
    maxGuests: 20, durationHours: 3,  badge: '🎈 Perfect Start',
    isPopular: false, accentColor: '#FF6BB5',
    features: ['Printed banner with child\'s name','Colorful balloons (50)','Cartoon characters (2)','Printed T-shirt for child','Deluxe gift box for child','Gifts & toys for guests','Printed cake 2kg','DJ & Music','Tele-match games','Puppet show','Magician show'],
  },
  {
    id: 2,
    title: 'Medium Celebration',      price: 30000, currency: 'EGP',
    maxGuests: 35, durationHours: 4,  badge: '⭐ Most Popular',
    isPopular: true,  accentColor: '#FF6BB5',
    features: ['All Small features included','Colorful balloons (100)','Cartoon characters (3)','Professional DJ with sound system','Interactive tele-match games','Printed cake 3kg','Photography (50 photos)','Puppet show','Magician show'],
  },
  {
    id: 3,
    title: 'Premium Experience',      price: 50000, currency: 'EGP',
    maxGuests: 50, durationHours: 5,  badge: '💎 All-Inclusive',
    isPopular: false, accentColor: '#7C3AFF',
    features: ['All Medium features included','Colorful balloons (150)','Cartoon characters (4)','Professional puppet theater show','Magician show with magic tricks','Printed cake 5kg + mini cakes','Photography + Video coverage','Photo booth corner with props','VIP gifts for child'],
  },
]

export default function Packages() {
  const { data: packages, isLoading } = usePackages()

  const items = packages?.length
    ? packages.slice(0, 3).map((p) => ({
        id: p.id, title: p.title, price: p.price, currency: p.currency,
        maxGuests: p.max_guests, durationHours: p.duration_hours,
        badge: p.badge, isPopular: p.is_featured, accentColor: p.color_accent,
        features: p.features,
      }))
    : FALLBACK_PACKAGES

  return (
    <>
      <PackagesHero />

      {/* Cards grid */}
      <section className="section-padding bg-gradient-to-b from-background to-light-300">
        <div className="container-custom">
          <SectionTitle
            eyebrow="All Packages"
            title="Find Your Perfect Celebration"
            subtitle="Every package includes our signature Farafeero magic — from setup to teardown."
          />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
            {isLoading
              ? Array(3).fill(null).map((_, i) => (
                  <div key={i} className="h-[560px] skeleton" />
                ))
              : items.map((pkg, i) => (
                  <PackageCard key={pkg.id} {...pkg} index={i} />
                ))}
          </div>
        </div>
      </section>

      <PackageComparison />
      <Testimonials />
      <CTA />
    </>
  )
}
